module.exports = "<div id=\"bar\">\n  <div id=\"logo\"></div>\n<div id=\"right-side\">\n  <div class=\"dropdown\">\n    <button class=\"dropbtn\"><b>Информация</b></button>\n    <div class=\"dropdown-content\">\n      <a href=\"#\">Регистрация/Авторизация</a>\n      <a href=\"#\">Обратная связь</a>\n    </div>\n  </div>\n</div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/bar/bar.component.html
// module id = ./src/app/components/bar/bar.component.html
// module chunks = main